import React from "react";
import two from "../../Assests/2.jpg";

const ServiceMeghauli = () => {
  return (
    <>
      <div className="container-fluid" >
        <div className="row">
          <div className="col-md-6 padding-0">
            <div className="home-room-image">
              <img src={two} alt="" className="img-fluid" />
            </div>
          </div>
          <div className="col-md-6 home-room-card" id="rooms">
            <div className="home-room-text">
              <h1>Suite</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure olor in
                reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p>
            </div>
            <ul>
              <li>
                <a href="{{url('#')}}" className="meghauli-btn-1">
                  <p>Learn More</p>
                </a>
              </li>
              <li>
                <a href="{{url('#')}}" className="meghauli-btn-1">
                  <p>Learn More</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6 home-room-card">
            <div className="home-room-text">
              <h1>Apartment</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure olor in
                reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p>
            </div>
            <ul>
              <li>
                <a href="{{url('#')}}" className="meghauli-btn-1">
                  <p>Learn More</p>
                </a>
              </li>
              <li>
                <a href="{{url('#')}}" className="meghauli-btn-1">
                  <p>Learn More</p>
                </a>
              </li>
            </ul>
          </div>
          <div className="col-md-6 padding-0">
            <div className="home-room-image">
              <img src={two} alt="" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6 padding-0">
            <div className="home-room-image">
              <img src={two} alt="" className="img-fluid" />
            </div>
          </div>
          <div className="col-md-6 home-room-card">
            <div className="home-room-text">
              <h1>Other rooms</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure olor in
                reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p>
            </div>
            <ul>
              <li>
                <a href="{{url('#')}}" className="meghauli-btn-1">
                  <p>Learn More</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceMeghauli;
